import { Services } from '~/constants/services';
import { push } from 'connected-react-router';
import { matchPath } from 'react-router-dom';

// Routes utils
export const getMatch = ({ pathname, route }) =>
  matchPath(pathname, {
    path: route,
  });

export const getParams = ({ pathname, route }) => {
  const match = getMatch({ pathname, route });
  return match?.params || null;
};

export const goTo = (path) => push(path);

export const DEFAULT_TAB_ID = 'queue';

// Profiles routes
export const profileServicePages = {
  route: `/profile/:service(${Services.map((service) => service.name).join(
    '|'
  )})`,
};
export const profilePages = {
  route: '/profile/:profileId',
  getRoute: ({ profileId }) => `/profile/${profileId}`,
  goTo: ({ profileId }) => push(`/profile/${profileId}`),
};

export const profileTabPages = {
  route: '/profile/:profileId/tab/:tabId',
  getRoute: ({ profileId, tabId }) => `/profile/${profileId}/tab/${tabId}`,
  defaultRoute: '/profile/:profileId/tab/queue',
  goTo: ({ profileId, tabId = 'queue' }) =>
    push(`/profile/${profileId}/tab/${tabId}`),
};

export const profileChildTabPages = {
  route: '/profile/:profileId/tab/:tabId/:childTabId?',
  getRoute: ({ profileId, tabId, childTabId }) =>
    `/profile/${profileId}/tab/${tabId}/${childTabId}`,
  goTo: ({ profileId, tabId, childTabId }) =>
    push(`/profile/${profileId}/tab/${tabId}/${childTabId}`),
};

export const isServiceRoute = ({ pathname }) =>
  getParams({ pathname, route: [profileServicePages.route] });

export const getProfilesParams = ({ pathname }) => {
  return getParams({
    pathname,
    route: [profileChildTabPages.route, profilePages.route],
  });
};

// Miscellaneous routes
export const generic = {
  route: '/',
  goTo: () => push('/'),
};

// Preferences routes
export const preferencesPage = {
  route: '/preferences',
  goTo: () => push('/preferences'),
};

export const preferencesAppsExtras = {
  route: '/preferences/appsandextras',
  goTo: () => push('/preferences/appsandextras'),
};

export const preferencesSecurity = {
  route: '/preferences/security',
  goTo: () => push('/preferences/security'),
};

export const preferencesGeneral = {
  route: '/preferences/general',
  goTo: () => push('/preferences/general'),
};

export const preferencesNotifications = {
  route: '/preferences/notifications',
  goTo: () => push('/preferences/notifications'),
};

// Campaigns routes
export const campaignsPage = {
  route: '/campaigns',
  goTo: () => push('/campaigns'),
};

export const campaignCreate = {
  route: '/campaigns/new',
  goTo: () => push('/campaigns/new'),
};

export const campaignEdit = {
  route: '/campaigns/:id/edit/',
  goTo: ({ campaignId, from }) =>
    push(`/campaigns/${campaignId}/edit`, { from }),
};

export const campaignTab = {
  route: '/campaigns/:id/:tab/',
  getRoute: ({ campaignId, tab }) => `/campaigns/${campaignId}/${tab}`,
  goTo: ({ campaignId, tab }) => push(`/campaigns/${campaignId}/${tab}`),
};

// Content Routes
export const contentPage = {
  route: '/content',
  goTo: () => push('/content'),
};

export const contentCreate = {
  route: '/content/new',
  goTo: () => push('/content/new'),
};

// Blueprints Routes
export const blueprintsPage = {
  route: '/recipes',
  goTo: () => push('/recipes'),
};

// Organization Routes
export const organization = {
  route: '/org/:id/',
  goTo: ({ orgId }) => push(`/org/${orgId}`),
};

// Calendar Routes
export const calendarPage = {
  route: '/calendar',
  goTo: () => push('/calendar'),
};

export const calendarMonth = {
  route: '/calendar/month',
  goTo: () => push('/calendar/month'),
  goToWithChannel: ({ channelId }) =>
    push({
      pathname: '/calendar/month',
      state: { channel: channelId },
    }),
};

export const calendarWeek = {
  route: '/calendar/week',
  goTo: () => push('/calendar/week'),
  goToWithChannel: ({ channelId }) =>
    push({
      pathname: '/calendar/week',
      state: { channel: channelId },
    }),
};

// Composer Routes
export const compose = {
  route: '/compose',
  goTo: () => push('/compose'),
};
